import { ErrorPage } from '@common/ErrorPage'
import { LoadingPage } from '@common/LoadingPage'
import { DetailView } from '@components/enitity'
import { withDetailView } from '@components/enitity/detail/Detail.view'
import { SectionHeading } from '@components/section'
import { FlatsTable } from '@features/flats'
import { LandlordInactiveToggle } from '@features/landlords/components/LandlordInactiveToggle'
import { LandlordInviteButton } from '@features/landlords/components/LandlordInviteButton'
import { LandlordsForm } from '@features/landlords/components/LandlordsForm.tsx'
import { usePatchClient } from '@services/users/mutations'
import { useClientDetail } from '@services/users/queries/useClientDetail'
import { Building2, ClipboardList } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { UserUpdate } from 'types/api'

function LandlordsDetailContent() {
  const { id } = useParams()
  const { t } = useTranslation('users')
  const { data, isLoading } = useClientDetail(id)
  const { mutate: updateLandlord } = usePatchClient()

  function submitForm({ body }: { body: UserUpdate }) {
    // birth_date already arrives as an ISO `YYYY-MM-DD` string from DatePicker.
    if (body.phone) {
      body.phone = body.phone.replace(/\s/g, '')
    }
    const o = Object.fromEntries(
      Object.entries(body).filter(([_, v]) => v != null)
    )
    updateLandlord({ id, body: o })
  }

  if (isLoading) {
    return <LoadingPage />
  }

  if (!data) {
    return <ErrorPage />
  }

  const name =
    `${data.first_name ?? ''} ${data.last_name ?? ''}`.trim() ||
    data.email ||
    '—'

  return (
    <DetailView.Root>
      <DetailView.Breadcrumb
        parentLabel={t('landlords')}
        parentTo="/admin/landlords"
        current={name}
      >
        <div className="ml-auto flex shrink-0 items-center gap-5">
          <LandlordInactiveToggle landlord={data} />
          <LandlordInviteButton landlord={data} />
        </div>
      </DetailView.Breadcrumb>

      <DetailView.Content>
        <div className="space-y-8">
          <section>
            <SectionHeading icon={ClipboardList}>
              {t('form.common.detail', { defaultValue: 'Detail' })}
            </SectionHeading>
            <LandlordsForm data={data} submitForm={submitForm} />
          </section>

          <section>
            <SectionHeading icon={Building2}>
              {t('flats', { defaultValue: 'Byty' })}
            </SectionHeading>
            <FlatsTable landlordId={id} />
          </section>
        </div>
      </DetailView.Content>
    </DetailView.Root>
  )
}

export const LandlordsDetail = withDetailView(
  LandlordsDetailContent,
  'Landlord Detail'
)
